import { client } from "@/config/client"

interface UpdateDeckSetParams {
  flashcardId: string
  body: {
    name: string
  }
}

export default function updateDeckSet({ flashcardId, body }: UpdateDeckSetParams) {
  return client.put<void, UpdateDeckSetParams["body"]>(`/v1/deck-sets/${flashcardId}`, body)
}
